import { Hide } from '@on3/ui-lib/components/Hide';
import { useModal } from '@on3/ui-lib/components/Modal/Provider';
import { Barrier } from '@on3/ui-lib/components/Subscription/Templates/Barrier';
import { useArticle, useAuth } from '@on3/ui-lib/index';
import { type PurchaseModalProps } from '@on3/ui-lib/types/purchase';
import { getReferrer } from '@on3/ui-lib/utils/tracking';
import { RegWallBarrier } from '@public/components/Headlines/RegWallBarrier';
import { useEffect } from 'react';

import styles from './ArticleBarrier.module.scss';

export const ArticleBarrier = () => {
  const { article } = useArticle();
  const { user } = useAuth();
  const { showModal } = useModal();

  const isPremium = article?.isPremium ?? false;
  const referrer = getReferrer();
  const isGated =
    (article?.tags?.some((t) => t.name === 'regWall') &&
      !user?.uid &&
      ['twitter', 'facebook'].includes(referrer)) ??
    false;

  const showLogin = () => {
    showModal('user.auth');
  };

  const showRegister = () => {
    showModal('user.auth', { defaultView: 'register' });
  };

  const showJoin = (props: PurchaseModalProps) => {
    showModal('user.join', props, 'screen');
  };

  useEffect(() => {
    if (isPremium || isGated) {
      document.body.classList.add('blocker-active');
    } else {
      document.body.classList.remove('blocker-active');
    }

    return () => {
      document.body.classList.remove('blocker-active');
    };
  }, [isPremium, isGated]);

  // Free article - no barrier needed
  if (!isPremium && !isGated) {
    return null;
  }

  return (
    <>
      {isPremium && <Barrier handleJoin={showJoin} handleLogin={showLogin} />}
      {isGated && (
        <RegWallBarrier handleLogin={showLogin} handleRegister={showRegister} />
      )}
      <div className={styles.blocker} id="blocker" />
      <Hide classes={['.adthrive-ad', '.adhesionAd', '[data-gg-moat]']} />
    </>
  );
};
